import React from 'react'
import { Autocomplete, Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, Grid, Paper, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { fieldDateFormat } from '../../../constants'
import moment from 'moment'
import { InfoOutlined } from '@mui/icons-material'

const FilterCard = ({ dropDownLoader, onFieldChange, onFocusChange, filterData, error, onApplyFilter, onResetFilter, currencies = [], filterType = 'global', onFilterTypeChange }) => {
  const currencyOptions = currencies.map((currency) => ({ label: currency?.name, value: currency?.id }))
  const isGraphFilterType = filterType === 'graph'
  return (
    <Paper sx={{ padding: 2, background:'EAEAEA',margin:1 }}>
      <Grid container spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <Grid size={{ md: 12, xs: 12 }}>
          <FormControl>
            <Grid container spacing={1} alignItems="center">
              <FormLabel sx={{ fontSize: '13px', fontFamily: 'Roboto-Medium', color: '#333', mr: 1, '&.Mui-focused': { color: '#333' } }}>Filter Type</FormLabel>
              <RadioGroup
                row
                aria-labelledby="filter-type-label"
                value={filterType}
                onChange={(e) => onFilterTypeChange?.(e.target.value)}
              >
                <FormControlLabel value="global" control={<Radio size="small" />} label={<Typography fontSize="13px">Global</Typography>} />
                <FormControlLabel value="graph" control={<Radio size="small" />} label={<Typography fontSize="13px">Graph</Typography>} />
              </RadioGroup>
            </Grid>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={1} alignItems="stretch">
        <Grid size={{ md: 10, xs: 12 }}>
          <Grid container spacing={1} alignItems="stretch">
            <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  required
                  disabled={isGraphFilterType}
                  label="Date From"
                  value={filterData?.date_from ? moment(filterData.date_from) : null}
                  onChange={(data) => {
                    onFieldChange("date_from", data);
                    onFocusChange("date_from");
                  }}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      helperText: error?.date_from,
                      error: error?.date_from,
                      onFocus: () => { onFocusChange("date_from") }
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("date_from", null);
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  maxDate={filterData?.date_to ? moment(filterData?.date_to) : null}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  required
                  disabled={isGraphFilterType}
                  label="Date To"
                  value={filterData?.date_to ? moment(filterData.date_to) : null}
                  onChange={(data) => {
                    onFieldChange("date_to", data);
                    onFocusChange("date_to");
                  }}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      helperText: error?.date_to,
                      error: error?.date_to,
                      onFocus: () => { onFocusChange("date_to") }
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("date_to", null);
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  minDate={filterData?.date_from ? moment(filterData?.date_from) : null}
                />

              </LocalizationProvider>
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                options={currencyOptions}
                disabled={isGraphFilterType || dropDownLoader?.display_currency}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                noOptionsText={dropDownLoader?.display_currency ? "Loading..." : "No Option Available"}
                getOptionLabel={(option) => option?.label || ""}
                value={filterData?.display_currency_id || null}
                onChange={(e, value) => onFieldChange("display_currency_id", value)}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                      <TextField
                        {...params}
                        label="Display Currency"
                        margin='normal'
                        size='small'
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                          input: {
                            ...params?.InputProps, endAdornment: <>{dropDownLoader?.display_currency && <CircularProgress color="inherit" size={20} />}
                              {params?.InputProps?.endAdornment}
                            </>
                          }
                        }}
                      />
                    </Tooltip>)
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ md: 2, xs: 12 }} >
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start', gap: '8px',paddingTop:5 }}>
            <Button variant='contained' size='small' onClick={onApplyFilter} disabled={isGraphFilterType || !(filterData?.date_from || filterData?.date_to || filterData?.display_currency_id )}>Apply</Button>
            <Button variant='outlined' size='small' onClick={onResetFilter} disabled={isGraphFilterType || !(filterData?.date_from || filterData?.date_to || filterData?.display_currency_id )}>Reset</Button>
          </div>
        </Grid>
      </Grid>
      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, mt: 1.5, px: 1, py: 0.5, borderRadius: 2, bgcolor: "#FFF8E1", border: "1px solid #FFE082", color: "#8A6D1D", }} >
        <InfoOutlined sx={{ fontSize: 16 }} />
        <Typography fontSize='11px'>
          By default, data from the last <strong>1 year</strong> is displayed when no date filters are applied.
        </Typography>
      </Box>
    </Paper>
  )
}

export default FilterCard